import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20geometric%20shapes%20in%20soft%20golden%20amber%20and%20cream%20gradients%2C%20minimalist%20corporate%20design%2C%20elegant%20modern%20background%2C%20subtle%20texture%2C%20professional%20atmosphere%2C%20inspiring%20corporate%20environment&width=1600&height=600&seq=cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 to-foreground-950/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
            准备好开启您的 <strong className="text-primary-400">aqdlt</strong> 之旅了吗？
          </h2>
          <p className="text-sm md:text-base text-background-50/80 mb-8 leading-relaxed">
            无论您是初创团队还是大型企业，aqdlt 都能为您提供最合适的数字化解决方案。
            立即联系我们，获取专属方案咨询。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="inline-flex items-center px-8 py-3 text-sm font-medium rounded-full bg-primary-500 text-background-50 transition-all duration-300 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              立即咨询
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/chenggong-anli"
              className="inline-flex items-center px-8 py-3 text-sm font-medium rounded-full border border-background-50/30 text-background-50 transition-all duration-300 hover:bg-background-50/10 whitespace-nowrap cursor-pointer"
            >
              查看成功案例
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}